export class NetworkError extends Error {
    /** Network response status code. */
    readonly statusCode: number;

    constructor(statusCode: number, message?: string) {
        super(message);

        this.statusCode = statusCode;
    }

    /**
     * Returns a {@link NetworkError} representing a 204 NO CONTENT error.
     *
     * @returns `NetworkError`.
     */
    static noContent(): NetworkError {
        return new NetworkError(204, 'No content');
    }

    /**
     * Returns a {@link NetworkError} representing a 404 RESOURCE NOT FOUND error.
     *
     * @returns `NetworkError`.
     */
    static contentNotFound(): NetworkError {
        return new NetworkError(404, 'No content found');
    }
}
